<template>
    <rkm-modal
        :buttons="['cancel']"
        :title="`Paciente: ${item.paciente}`"
        ref="Modal"
        extraLarge
    >
        <rkm-table
            :fields="fields"
            :items="items"
            no-footer-sorting
            sort-by=""
        >
        </rkm-table>

    </rkm-modal>
</template>

<script>
// Vuex
import { mapActions } from "vuex";

// Mixins
import { repository, error, data, object, stringCase, file } from "@/mixins";

export default {
    computed: {
        fields() {
            return [
                { key: 'usuarioCadastro', label: 'Usuário que Cadastrou' },
                { key: 'usuarioEdicao', label: 'Usuário que Alterou' },
                { key: 'destino', label: 'Destino' },
                { key: 'veiculo', label: 'Veículo' },
                { key: 'acompanhantes', label: 'Acompanhantes' },
                { key: 'acompanhantes', label: 'Quantidade de Acompanhante' },
                { key: 'dataHoraSaida', label: 'Data/hora da saída' },
                { key: 'motivo', label: 'Motivo viagem' },
                { key: 'status', label: 'Status' },
                { key: 'dataHoraModificacao', label: 'Data/hora da Modificação' }
            ];
        },
    },
    created() {
        this.repositories = {
            agendar:this.getConectaSusRepository('transportePaciente.agendar')
        };
    },
    data: () => ({
        items: [],
        item: {
            paciente: ''
        },


    }),
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load(id) {
            this.setLoading();
            this.repositories.agendar
                .getHistoricos(id)
                .then(({data}) => {
                    this.items = data;
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading());
        },
        open(item) {
            this.items = [];
            this.item = item;
            this.$refs.Modal.show()
            this.load(item.id);
        },
        save() {
            this.$refs.Modal.hide();
        }
    },

    mixins: [repository, error, data, object, stringCase, file],
}
</script>